export default {
  title: "Сауда нүктелері",
  name: "Сауда нүктесінің атауы",
  namingNoSpecified: "Атауы көрсетілмеген",
  tradingPoint: "Сауда нүктесі",
  addressNoSpecified: "Мекенжай көрсетілмеген",
  info: "Сауда нүктесі туралы ақпарат",
  add: {
    title: "Сауда нүктесін құру",
    noOperations: "Ешқандай операция жасалмады",
  },
  historyOperation: "Чектер тарихы",
  employee: "Қызметкер",
  customer: "Сатып алушы",
  source: "Дереккөз",
  typeOperation: "Операция түрі",
  typeActivity: "Қызмет түрі",
  writing: "Шегеру",
  accrual: "Есептеу",
  sumBuy: "Сатып алу сомасы",
  sumWrite: "Шегеру сомасы",
  toPay: "Төлеуге",
  totalCashback: "Жалпы сыйақы",
  salePopup: "Жеңілдік",
  types: {
    balance_up: "Балансты толтыру",
    balance_down: "Қаражат шегеру",
    tsp_approve: "Чек бойынша есеп айырысу",
    balance_refill: "Балансты толтыру",
    tariff_change: "Тариф сатып алу",
    cashback_approve: "Клиенттік сапар",
    cashback_charge: "Чек. Ұпайларды шегеру",
    certificate_charge: "Есептеу. Сыйлық картасын пайдалану",
    certificate_debt: "Шегеру. Сыйлық картасын шығару",
    certificate_refund: "Сыйлық картасын шығарғаны үшін қайтарым",
    rc_withdraw: "Чек. Ұпай қабылдау",
    tsp_commission_fee: "Чек. Комиссия",
    tsp_commission_revert:
      "1 сәуірден есептеу күніне дейін қате шегерілген соманы қайта есептеу",
    tsp_commission_correct:
      "Қабылданған ұпайлардың 1%-ы мөлшерінде есеп айырысуды түзету",
    manual_commission_approve: "Чек. Комиссия бойынша есеп айырысу",
    manual_withdraw: "Қаражат шығару",
    cashback_decline: "Чекті болдырмау",
    rc_processing_receipts: "Касса аппаратының чегі",
    cashback_approve_decline: "Клиенттік сапар үшін есептеуді болдырмау",
    partner_manual_withdraw: "Қаражат шегеру",
    inner_cashback_charge: "Чек. Сыйақыны шегеру",
    inner_cashback_approve: "Чек бойынша есеп айырысу",
    tsp_approve_payment: "Чек. Қаражат шегеру",
    rc_withdraw_approve: "Чек. Ұпаймен төлем үшін есептеу",
    withdraw_payment: "Чек. Қаражат шегеру",
    prodazha_top_mesta: "RCPay-да ТОП-орын сатып алу",
    reserving_funds_withdrawal: "Төлемге резервтелді",
    refund_reserved_funds_withdrawal: "Төлемге резервті қайтару",
    withdraw_reserved_funds: "Қаражат шығару",
  },
  organizations: "Заңды тұлға",
  moderationModalTitle: "Модерациядан хабарлама",
  clients: "клиентке: ",
  other: "комиссия: ",
  total: "Барлығы: ",
  draft: "Қаралама",
  itsAppearAfterCreateShop: "Олар сауда нүктесін құрғаннан кейін мұнда шығады",
  inRCPay: {
    published: "RC PAY-да жарияланған",
    unpublished: "RC PAY-да жарияланбаған",
  },
  promotion: "Жарнама",
  openInRCPay: "RC PAY-да ашу",
  couldntSendShopToModeration: "Сауда нүктесін сақтау мүмкін болмады",
  shopChangesSuccessSaved: "Сауда нүктесінің өзгерістері сәтті сақталды",
  forLayoultyCreateEmployee:
    "Адалды бағдарламада жұмыс істеу үшін «Кассирлер» бөлімінде кассир құрып, оны осы сауда нүктесіне бекіту қажет.",
  changesSendedToModeration:
    "Сауда нүктесінің өзгерістері модерацияға жіберілді",
  someChangesNeedModeration:
    "Енгізілген кейбір өзгерістер модерацияны талап етеді",
  changesUpdateAfterModeration:
    "RC PAY-да көрсетілетін картада олар модератор растағаннан кейін ғана жаңартылады.",
  connectedPaymentMethod: "Сауда нүктесіне төлем тәсілдері қосылған.",
  ifNeedDeleteConnectWithUs:
    "Оны жою қажет болса, техникалық қолдауға хабарласыңыз",
  ifNeedDeleteConnectWithUsSuccess: "Электрондық пошта буферге көшірілді",
  someFieldsUncorrect: "Кейбір өрістер дұрыс толтырылмаған",
  backToEditingToFixIt:
    "Өзгерту үшін қайта өңдеуге оралыңыз. Немесе «Өткізіп жіберу» батырмасын басыңыз, қателері бар өрістердегі деректерді сақтамай шығу үшін.",
  wannaQuit: "Шығуды қалайсыз ба?",
  allNotSavedChangesWillRemove:
    "Сақталмаған барлық өзгерістер жойылады. Оларды сақтау үшін артқа оралыңыз.",
  cancelCreationPointModal: {
    title: "Сауда нүктесін құрудан бас тарту керек пе?",
    subtitle:
      "Сауда нүктесі туралы енгізілген ақпарат сақталмайды. Өңдеуді жалғастыру үшін «Артқа» батырмасын басыңыз.",
  },
  moderationModal: {
    title: "Сауда нүктесі сәтті құрылып, модерацияға жіберілді",
    subtitle:
      "Адалды бағдарламада жұмыс істеу үшін «Кассирлер» бөлімінде кассир құрып, оны осы сауда нүктесіне бекіту қажет.",
  },
  deletePromotionModal: {
    title: "Жарнамасы белсенді сауда нүктесін жойғыңыз келе ме?",
    subtitle:
      "Жойғаннан кейін жарнама қызметтері тоқтатылады. Жарнамаға төленген қаражат қайтарылмайды. Сауда нүктесінің деректерін қалпына келтіру мүмкін болмайды.",
  },
  deleteModal: {
    title: "Сауда нүктесін жойғыңыз келе ме?",
    subtitle: "Жойғаннан кейін деректерді қалпына келтіру мүмкін емес.",
    shopDeleted: "Сауда нүктесі жойылды",
  },
  lessTariffModal: {
    title: "Тарифіңіз бойынша максималды сауда нүктесін құрдыңыз",
    subtitle: "Көбірек сауда нүктесін құру үшін басқа тариф сатып алу қажет.",
  },
  validation: {
    specifyMailOrRemoveField:
      "Эл. пошта мекенжайын көрсетіңіз немесе өрісті өшіріңіз",
    specifyLinkAddressOrRemove:
      "Сілтеме мекенжайын көрсетіңіз немесе өрісті өшіріңіз",
    couldntSendShopToModeration:
      "Сауда нүктесін модерацияға жіберу мүмкін болмады",
    someImagesCouldntProcess:
      "Кейбір суреттерді өңдеу мүмкін болмады. Басқа суреттерді жүктеп көріңіз",
  },
  creationTab: {
    main: "Негізгі",
    loyalty: "Адалды бағдарлама",
    addressAndOpeningHours: "Мекенжай және жұмыс уақыты",
    contacts: "Байланыс",
    foto: "Фото",
  },
  stepFromTo: "Қадам {from} / {total}",
  createShopAndContinue: "Сауда нүктесін құрып, жалғастыру",
  message: {
    dataSavedToDraft: "Сауда нүктесінің деректері қараламаға сақталды",
    dataSavedAndSendToModeration: "Өзгерістер сақталып, модерацияға жіберілді",
    dataSuccessSaved: "Өзгерістер сәтті сақталды",
    fillCorrectSpecifiedFields: "Көрсетілген өрістерді дұрыс толтырыңыз",
    fillCorrectAllRequiredFields: "Барлық міндетті өрістерді дұрыс толтырыңыз",
  },
  describeYourCompany:
    "Компанияңызды толық сипаттаңыз. Мәтінде хэштег (#) пен смайликтерді қолданбаңыз. Мекенжай, байланыс деректері, жұмыс режимі бөлек — келесі қойындыларда көрсетіледі.",
  willDisplayToUserInRCPay: "RC PAY қолданушыларында көрсетіледі",
  activityTooltip:
    "RC PAY іздеу нәтижесінде таңдалған санаттар бойынша көрсетіледі.",
  afterModerationEntityEditingDisable:
    "Модерация расталғаннан кейін заңды тұлғаны өңдеу мүмкін емес. Өзгерту үшін техникалық қолдауға хабарласыңыз.",
  description: "Сауда нүктесінің сипаттамасы",
  charsLimit: {
    min: "Ең аз таңба саны – {minChars}",
    max: "Ең көп таңба саны – {maxChars}",
  },
  features: "Ерекшеліктер",
  selectedFeaturesWillDisplayInCard:
    "Таңдалған параметрлер RC PAY-дағы картада тегтер ретінде көрсетіледі",
  catalogTitles: "RC PAY-дегі тауарлар / қызметтер блогының атауы",
  catalogTitlesTooltip:
    "RC PAY-дегі сіздің нысан бетінде қолданылатын тауарлар / қызметтер блогының жалпы атауы.",
  totalPercentReward: "Жалпы сыйақы пайызы",
  totalPercentRewardValue:
    "Жалпы есептелетін сыйақы пайызы (4-тен 25-ке дейін).",
  rewardWillPayToClients:
    "Клиенттерге сыйақы төлеу сценарийлеріне сәйкес төленеді.",
  checkRewardDistribution: "Сыйақы бөлу сценарийлерін қарау",
  activeWait: "Есептеу кідірісі",
  activeWaitTooltip:
    "Клиент сатып алған сәттен бастап (0-ден 14 күнге дейін) сыйақы есептелетін күн саны",
  clientDiscount: "RC PAY клиенттеріне жеңілдік",
  clientDiscountTooltip:
    "Жеңілдік пайызы (0-ден 99-ға дейін), RC GROUP адалдығы бағдарламасының клиенттеріне беріледі",
  shopPaylable: "Сауда нүктесі RC ұпайларымен төлем қабылдайды",
  shopPaylableDescription:
    "RC PAY тіркелген клиенттері сатып алу құнының 99,9%-ына дейін RC ұпайларымен төлей алады",
  enteredDataNotNeedModeration:
    "Енгізілген деректер модерацияны қажет етпейді және сауда нүктесі құрылғаннан кейін бірден қолданылады (егер заңды тұлға расталған болса).",
  address: "Мекенжай",
  ifNoYourShopSelectNear:
    "Картада нысаныңыздың мекенжайы жоқ болса, ең жақынын таңдаңыз да, техникалық қолдауға хабарласыңыз",
  startEnteringAddress: "Мекенжайды енгізіп, тізімнен таңдаңыз",
  addressComment: "Мекенжайға түсініктеме",
  specifyWayToGetYouShop:
    "Нысаныңызға қалай жетуді, алдын ала қоңырау шалуды немесе басқа қосымша ақпаратты көрсетіңіз (міндетті емес)",
  period: {
    workdays: "Аптаның жұмыс күндері ДС-ЖМ",
    weekend: "Демалыс күндері СБ-ЖС",
    allDay: "Күн сайын ДС-ЖС",
    aroundClock: "Тәулік бойы 24/7",
  },
  catalog: "Каталог",
  intervals: "Интервалдар",
  weekdays: "Апта күндері",
  selectedAllDays: "Барлық апта күндері таңдалды",
  workHoursInOtherDays: "Басқа күндердегі жұмыс уақыты",
  workDays: "Жұмыс күндері",
  workDaysMobileSubtitle:
    "Сауда нүктесі бір кесте бойынша жұмыс істейтін күндерді немесе интервалды таңдаңыз.",
  workDaysTooltips: [
    "Мысалы, жұмыс күндері ДС-ЖМ 10:00-20:00 аралығы.",
    "Содан кейін «Басқа күндердегі жұмыс уақыты» батырмасын басып, басқа күндерді таңдаңыз (мысалы, СБ 12:00-16:00).",
  ],
  specifyWorkTimeInSelectedDays:
    "Таңдалған күндердегі жұмыс уақытын көрсетіңіз",
  publicTradingPoint: "Сауда нүктесін rcpay.ru сайтында жариялау",
  publicTTDescription: [
    "Сауда нүктесі rcpay.ru сайтында және RC PAY қосымшасында көрсетіледі.",
    "RC PAY-да жариялау модератор растағаннан кейін ғана жүзеге асырылады. Жариялаудан алып тастау үшін бұл опцияны өшіріңіз.",
  ],
  workOnline: "Сауда нүктесі онлайн жұмыс істейді",
  workOnlineDescription: [
    "Қызметтер / тауарлар тек қашықтан / жеткізу арқылы жүзеге асырылады.",
    "«Мекенжай» өрісінде қала картасында көрсету үшін шамамен мекенжайды енгізіңіз. Ол карточкада көрсетілмейді, оның орнына «Онлайн» сөзі көрсетіледі.",
  ],
  time: "Жұмыс уақыты",
  specifyPhoneNumberOrRemove:
    "Телефон нөмірін көрсетіңіз немесе өрісті өшіріңіз",
  specifyMailOrRemove: "Поштаны көрсетіңіз немесе өрісті өшіріңіз",
  onlineService: "Онлайн-брондау сервисі",
  specifyLinkIfUseOtherServicesForOnline:
    "Егер дайын онлайн-брондау сервистерін қолдансаңыз, сілтемені осында енгізіңіз",
  linkAddress: "Сілтеме мекенжайы",
  addSiteOrSocialMedia: "Сайтқа немесе әлеуметтік желіге сілтеме қосу",
  linkName: "Сілтеменің атауы",
  linkNameTooltips: [
    "RC PAY-да қалай көрсетілетінін жазыңыз. Мысалы, «Сатып алу» немесе «Брондау».",
    "Егер ештеңе көрсетілмесе, сілтеменің мекенжайы көрсетіледі.",
  ],
  pointPhotos: "Сауда нүктесінің фотосуреттері",
  photosRequirements:
    "Мүмкіндігінше сапалы, сутаңбасыз, жазусыз және коллажсыз болуы тиіс",
  logo: "Логотип",
  photoRecomendation: "Суретке қойылатын талаптар",
  logoRecomendations: [
    "JPEG, JPG, PNG форматындағы файл, 10 Мб дейін, пропорция 1:1",
    "Логотип, тақырыптық сурет немесе фирмалық белгі болуы мүмкін",
    "Сапалы сурет, мекенжай, телефон және қосымша ақпаратсыз",
  ],
  uploadLogo: "Логотипті жүктеу",
  noClient: "Клиент жоқ",
  giftCard: "Сыйлық картасы",
  totalCashbackHints: [
    "Чекте жалпы сыйақы пайызы көрсетілген, бірақ ол операция жолындағы нақты шегерілген ұпайларға сәйкес келмеуі мүмкін.",
    "Бұл сатып алушының кім екеніне (ішкі немесе сыртқы клиент) және оның тарифіне байланысты.",
  ],
  previewInRCPay: "RC PAY-да алдын ала қарау",
  searchByTable: "Кесте бойынша іздеу",
};
